<template>
  <div id="water-level-chart">
    <dv-border-box-6>
      <div class="water-level-chart-title">本月已完成工单数量</div>
      <!--<div class="water-level-chart-details">
        累计已完成<span>{{totalCount}}</span>单
      </div>-->
      <div class="chart-container">
        <dv-water-level-pond :config="config" />
      </div>
    </dv-border-box-6>
  </div>
</template>

<script>
export default {
  name: 'WaterLevelChart',
  data () {
    return {
      totalCount: 0,
      config: {
        data: [20],
        shape: 'round',
        waveHeight: 20,
        waveNum: 2
      },
      lineId: undefined
    }
  },
  beforeMount(){
    const href = window.location.href
    const str = href.substr(href.indexOf("?")+1,href.length)
    const params = str.split('&')
    const code = params[0].split('=')[1]
    if (code){
      this.lineId = code;
    }
  },
  mounted () {
    const { getBigScreen } = this;
    getBigScreen();
    setInterval(getBigScreen, 30000);
  },
  methods: {
    async getBigScreen() {
      const data = await this.$http.post('https://apismt.moxitech.cn/admin-api/bigScreen/getWorkOrderCompletionRate',{
        lineId: this.lineId
      }).then(res=>{
        return res.data.data
      }).catch(e=>{
        console.log(e)
      });
      this.totalCount = data.workOrderTotal;
      this.config.data = [parseInt(data.workOrderCompleted)];
      this.config = { ...this.config };
    }
  }
}
</script>

<style lang="less">
#water-level-chart {
  width: 30%;
  box-sizing: border-box;
  position: absolute;
  height: calc(100% - 733px);
  left: 20px;
  top: 705px;
  flex-direction: column;

  .water-level-chart-title {
    font-weight: bold;
    height: 50px;
    display: flex;
    align-items: center;
    font-size: 20px;
    justify-content: center;
  }

  .water-level-chart-details {
    height: 15%;
    display: flex;
    justify-content: center;
    font-size: 16px;
    align-items: flex-end;

    span {
      font-size: 36px;
      font-weight: bold;
      color: #58a1ff;
      margin: 0 5px;
      margin-bottom: -5px;
    }
  }

  .chart-container {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0px;
  }

  .dv-water-pond-level {
    max-width: 90%;
    width: 200px;
    height: 200px;
    border: 10px solid #19c3eb;
    border-radius: 50%;

    ellipse {
      stroke: transparent !important;
    }

    text {
      font-size: 40px;
    }
  }
}
</style>
